module.exports = __webpack_public_path__ + "img/market.8419f7c0.jpg";